import type { FunctionComponent } from "react";

import type { OlympicEvents } from "~/components/olympic-widgets/today-highlights/types";

import {
  Athlete,
  Container,
  Description,
  Sport,
  SportDetails,
  StartTime,
  TimeContainer,
} from "./styles";

type Props = {
  className?: string;
} & OlympicEvents;

export const OlympicTodayHighlightsItem: FunctionComponent<Props> = ({
  athlete,
  className,
  description,
  sport,
  startTime,
}) => (
  <Container className={className}>
    <TimeContainer>
      <StartTime>{startTime}</StartTime>
    </TimeContainer>

    <SportDetails>
      <Sport>{sport}</Sport>
      <Description>{description}</Description>
      <Athlete>{athlete}</Athlete>
    </SportDetails>
  </Container>
);

OlympicTodayHighlightsItem.displayName = "OlympicTodayHighlightsItem";
